import { ExtendedCartItem, Product } from '@@types'
import { ReactSVG } from 'react-svg'

import {
  useAuth,
  useLoginModal,
  useProfileCustomerModal,
} from '@features/auth'
import { useToggleFavorite } from '@features/favorite/hooks/useToggleFavorite'

import { cn } from '@shared/lib/cn'
import Button, { ButtonComponentProps } from '@shared/ui/button'

import styles from './styles.module.scss'



interface FavoriteButtonProps extends Pick<Product, 'id'> {
  className?: string;
  size?: 'large';
  isLarge?: boolean;
  isFavorite?: boolean;
  theme?: ButtonComponentProps['theme'];
  product?: Product | ExtendedCartItem;
}

export default function FavoriteButton ({
  className,
  size,
  isLarge,
  isFavorite = false,
  id,
  theme = 'grey',
  product,
}: FavoriteButtonProps) {
  const { user, requireRegistration } = useAuth()
  const { openProfileCustomerModal } = useProfileCustomerModal()
  const { openLoginModal } = useLoginModal()
  const { toggleFavorite } = useToggleFavorite()

  const favoriteClickHandler = () => {
    if (!user?.id) {
      openLoginModal()
    }
    else if (requireRegistration) {
      openProfileCustomerModal()
    }
    else {
      toggleFavorite(id, isFavorite, product)
    }
  }

  const commonClassName = cn(styles.root, className, size ? styles[size] : '', {
    [styles.active]: isFavorite,
  })

  if (isLarge) {
    return (
      <Button
        className={cn(commonClassName, styles.isLarge)}
        onClick={favoriteClickHandler}
        theme={theme}
      >
        <ReactSVG src="/icons/heart.svg" wrapper="span" />
      </Button>
    )
  }

  return (
    <button
      className={cn('reset-button', commonClassName)}
      type="button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        favoriteClickHandler()
      }}
    >
      <ReactSVG src="/icons/heart.svg" wrapper="span" />
    </button>
  )
}
